import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const rootElement = document.getElementById("root");

// Detect if HTML was pre-rendered by Playwright (prerender.py).
// Pre-rendered pages have substantial React output inside #root instead of just the loader shell.
// We use a marker attribute set by prerender.py to make this unambiguous.
const isPrerendered = rootElement.hasAttribute("data-prerendered");

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (isPrerendered) {
  // Hydrate the static HTML that was generated at build time — instant LCP, no flash.
  ReactDOM.hydrateRoot(rootElement, app, {
    onRecoverableError: (error, errorInfo) => {
      // Surface exact hydration mismatch details in production (React's default is opaque)
      // eslint-disable-next-line no-console
      console.error("[hydration]", error.message, errorInfo);
    },
  });
} else {
  // Standard client-side render (dev server or non-prerendered routes).
  ReactDOM.createRoot(rootElement).render(app);
}
